<template>
  <app-layout>
    <div v-loading.fullscreen="loading || !project">
      <!-- <app-stepper
      :scaffold="scaffold"
      :project="project"
      :current="1"
    /> -->

      <div
        class="max-w-screen-xl mx-auto px-5"
        v-if="project && scaffold"
      >
        <el-button class="mt-4" @click="copyProject()"
          ><i class="fas fa-chevron-left mr-1"></i> Copy and
          Edit Project</el-button
        >

        <div class="mt-4 mb-4 border-2 border-gray-50">
          <h2
            class="flex items-center p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Project Details
          </h2>

          <div class="m-4">
            <app-project-label-edit
              :project="project"
            ></app-project-label-edit>

            <div class="mt-2">
              Scaffold:
              <strong class="ml-1"
                >{{ scaffold.name }} ({{
                  project.version
                }})</strong
              >
            </div>

            <div
              v-if="
                project.presenter &&
                  project.presenter.properties.length
              "
            >
              <div
                class="mt-2"
                v-for="property in project.presenter
                  .properties"
                :key="property.label"
              >
                {{ property.label }}:
                <strong class="ml-1">{{
                  property.value
                }}</strong>
              </div>
            </div>
            <div
              class="my-2"
              v-if="
                project.presenter &&
                  project.presenter.entities.length
              "
            >
              <div>
                Entities:
                <el-tooltip
                  v-for="entity in project.presenter
                    .entities"
                  placement="top"
                  :key="entity.label"
                  :content="entity.value"
                  effect="light"
                >
                  <el-tag
                    type="info"
                    size="mini"
                    class="ml-2"
                    >{{ entity.label }}</el-tag
                  >
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-4 border-2 border-gray-50">
          <h2
            class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Preview
          </h2>

          <div
            v-if="previewUrlPoolingEnabled && !previewUrl"
            class="m-4"
          >
            <p class="font-bold text-blue-600">
              <i
                class="fas fa-circle-notch fa-spin mr-1"
              ></i>
              The preview is being created...
            </p>
            <p class="font-gray-700 mt-2">
              It may take between 5-10 minutes to provision.
            </p>
            <p class="font-gray-700 mt-2">
              You can close this window. We will
              <span class="font-bold">email you</span>
              once it's ready.
            </p>
            <a
              href="https://felipepastorelima.gitbook.io/scaffoldhub-v3/features/preview"
              target="_blank"
              class="block text-blue-600 mt-2"
            >
              Read more about the preview on the docs.
            </a>

            <div
              v-if="previewLogs"
              class="mt-6 bg-gray-900 text-white p-4 rounded-md max-h-96 max-w-full overflow-y-scroll"
            >
              <div class="overflow-x-auto">
                <pre
                  class="text-gray-300"
                  v-html="convertedPreviewLogs"
                ></pre>
              </div>
            </div>
          </div>

          <div v-if="previewUrl">
            <div class="m-4">
              <a :href="previewUrl" target="_blank">
                <el-button
                  class="w-full"
                  type="primary"
                  plain
                  ><i
                    class="fas fa-external-link-alt mr-1"
                  ></i>
                  Preview Application</el-button
                >
              </a>
            </div>
          </div>

          <div
            v-if="!previewUrlPoolingEnabled && !previewUrl"
            class="m-4"
          >
            <div class="font-semibold text-red-500">
              Something went wrong with the preview.
            </div>
            <div class="mt-3 text-gray-700">
              It is possible that some
              <span class="font-bold">entity</span> or
              <span class="font-bold">field name</span> of
              this project uses a javascript
              <span class="font-bold">protected word</span>
              or that some name is
              <span class="font-bold"
                >conflicting with the built-in code</span
              >.
              <br />
              Please enter in contact with
              <span class="font-bold"
                >support@scaffoldhub.io</span
              >
              if you don't mind about me taking a look at
              your project to check what went wrong.
            </div>

            <div
              v-if="previewLogs"
              class="mt-6 bg-gray-900 text-white p-4 rounded-md max-h-96 max-w-full overflow-y-scroll"
            >
              <div class="overflow-x-auto">
                <pre
                  class="text-gray-300"
                  v-html="convertedPreviewLogs"
                ></pre>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-4 border-2 border-gray-50">
          <h2
            class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Download
          </h2>
          <div class="m-4">
            <el-button
              v-if="
                !scaffold.free &&
                  !project.purchased &&
                  !premium &&
                  hasFunds
              "
              class="w-full"
              type="primary"
              @click="downloadOrPurchase"
              :loading="loadingDownload"
              ><i class="fas fa-download mr-1"></i>
              View/Download the Code (1 credit)</el-button
            >

            <el-button
              v-if="
                !scaffold.free &&
                  !project.purchased &&
                  !premium &&
                  !hasFunds
              "
              class="w-full"
              type="primary"
              @click="downloadOrPurchase"
              :loading="loadingDownload"
              ><i class="fas fa-lock mr-1"></i>
              View/Download the Code</el-button
            >

            <app-purchase-modal
              v-model="purchaseModalDownloadOpened"
              :referrer="referrer"
            ></app-purchase-modal>

            <el-button
              v-if="
                scaffold.free ||
                  project.purchased ||
                  premium
              "
              class="w-full"
              type="primary"
              @click="downloadOrPurchase"
              :loading="loadingDownload"
              ><i class="fas fa-download mr-1"></i>
              View/Download the Code</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AnsiToHtml from 'ansi-to-html';
import { mapGetters, mapActions } from 'vuex';
import * as Sentry from '@sentry/browser';

const convert = new AnsiToHtml();

export default {
  name: 'app-project-preview',

  props: ['projectId'],

  data() {
    return {
      purchaseModalDownloadOpened: false,
    };
  },

  async created() {
    if (!this.projectId) {
      this.$router.push('/');
      return;
    }

    this.$store
      .dispatch('project/setup', {
        projectId: this.projectId,
      })
      .then(() => {
        this.startPreviewUrlPooling();
      })
      .catch((error) => {
        Sentry.captureException(error);
        this.$router.push('/');
      });
  },

  computed: {
    ...mapGetters({
      currentUserUid: 'auth/currentUserUid',
      project: 'project/project',
      scaffold: 'scaffold/current',
      loading: 'project/loading',
      loadingDownload: 'project/loadingDownload',
      premium: 'credits/premium',
      hasFunds: 'credits/hasFunds',
      previewUrlPoolingEnabled:
        'project/previewUrlPoolingEnabled',
      previewLogs: 'project/previewLogs',
      previewUrl: 'project/previewUrl',
    }),

    convertedPreviewLogs() {
      return convert.toHtml(this.previewLogs);
    },

    referrer() {
      return `/project/${this.projectId}`;
    },
  },

  methods: {
    ...mapActions({
      download: 'project/download',
      clearPreviewUrlPooling:
        'project/clearPreviewUrlPooling',
      startPreviewUrlPooling:
        'project/startPreviewUrlPooling',
    }),

    beforeRouteLeave() {
      this.clearPreviewUrlPooling();
    },

    beforeDestroy() {
      this.clearPreviewUrlPooling();
    },

    copyShareLink() {
      const input = document.querySelector('#shareLink');
      input.select();

      try {
        const copied = document.execCommand('copy');

        if (!copied) {
          throw new Error();
        }
      } catch (err) {
        this.$message({
          message: 'Oops, unable to copy',
          type: 'error',
        });
      }
    },

    async downloadOrPurchase() {
      if (
        !this.scaffold.free &&
        !this.hasFunds &&
        !this.project.purchased
      ) {
        this.purchaseModalDownloadOpened = true;
        return;
      }

      if (
        !this.scaffold.free &&
        this.hasFunds &&
        !this.project.purchased &&
        !this.premium
      ) {
        try {
          await this.$confirm(
            `You'll be charged 1 credit for this operation.<br/>Do you want to continue?`,
            'Confirm',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              type: 'warning',
            },
          );
        } catch (error) {
          return;
        }
      }

      await this.download();

      this.$router.push({
        name: 'project-download',
        params: {
          projectId: this.projectId,
        },
      });
    },

    copyProject() {
      this.$router.push({
        name: 'builder',
        params: {
          scaffoldId: this.scaffold.id,
        },
        query: {
          version: this.project.version,
        },
      });
    },
  },
};
</script>

<style></style>
